export const MEMBERSHIP_NAME_PATTERN = /^[a-z0-9_]+$/
export const SPECIAL_CHARACTERS = /[-[\]{}()*+?.,\\^$|#]/g
export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
